import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BASE_URL = "https://meetwithlunar.com";

const ROUTE_SEO = {
    "/": {
        title: "Lunar — The social network for real life",
        description: "Lunar is the social network for real life, helping people find each other socially and professionally.",
    },
    "/networking": {
        title: "Lunar Network — Meet the right people",
        description: "Lunar Network helps professionals discover relevant people at conferences, coworking spaces and business events.",
    },
    "/events": {
        title: "Lunar Event Activation — Lunar",
        description: "Lunar event activation helps organisers get attendees connecting in real life.",
    },
    "/venue-kit": {
        title: "Get Lunar at your venue — Lunar",
        description: "Lunar for Venues provides branded materials for permanent venues and shared spaces.",
    },
    "/download": {
        title: "Download Lunar — The social network for real life",
        description: "Download Lunar, the social network for real life.",
    },
    "/privacy": {
        title: "Privacy Policy — Lunar",
        description: "Read the Lunar Privacy Policy.",
    },
    "/terms": {
        title: "Terms & Conditions — Lunar",
        description: "Read the Lunar Terms and Conditions.",
    },
    "/safety": {
        title: "Safety — Lunar",
        description: "Read Lunar's guidance for meeting people safely in real life.",
    },
    "/support": {
        title: "Support — Lunar",
        description: "Contact Lunar support for help with the app, venues, events or your account.",
    },
    "/child-safety": {
        title: "Child safety standards — Lunar",
        description: "Read Lunar's child safety standards and reporting information.",
    },
};

const setMeta = (key, value, attribute = "name") => {
    const selector = `meta[${attribute}="${key}"]`;
    let element = document.head.querySelector(selector);
    if (!element) {
        element = document.createElement("meta");
        element.setAttribute(attribute, key);
        document.head.appendChild(element);
    }
    element.setAttribute("content", value);
};

export const RouteSeo = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        const seo = ROUTE_SEO[pathname];
        const metadata = seo || {
            title: "Page not found — Lunar",
            description: "The page you are looking for could not be found.",
        };
        const canonicalUrl = `${BASE_URL}${pathname === "/" ? "/" : pathname}`;

        document.title = metadata.title;

        let canonical = document.head.querySelector('link[rel="canonical"]');
        if (!canonical) {
            canonical = document.createElement("link");
            canonical.setAttribute("rel", "canonical");
            document.head.appendChild(canonical);
        }
        canonical.setAttribute("href", canonicalUrl);

        setMeta("robots", seo ? "index, follow" : "noindex, follow");
        setMeta("description", metadata.description);
        setMeta("og:title", metadata.title, "property");
        setMeta("og:description", metadata.description, "property");
        setMeta("og:url", canonicalUrl, "property");
        setMeta("twitter:title", metadata.title);
        setMeta("twitter:description", metadata.description);
    }, [pathname]);

    return null;
};
